import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkCreateCarePlanMedicalNote } from '../types';

const onCreateCarePlanMedicalNote: IThunkCreateCarePlanMedicalNote = thunk(
  // @ts-ignore
  async ({ addCarePlanMedicalNotes }, payload) => {
    const { patientId, data } = payload;
    const medicalNote = await api.carePlanMedicalNotes
      .create(patientId, data)
      .then(res => res.data);
    addCarePlanMedicalNotes(medicalNote);
  },
);

export default onCreateCarePlanMedicalNote;
